import { render, staticRenderFns } from "./PropertyHistory.vue?vue&type=template&id=60d7814b&scoped=true&"
import script from "./PropertyHistory.vue?vue&type=script&lang=js&"
export * from "./PropertyHistory.vue?vue&type=script&lang=js&"
import style0 from "./PropertyHistory.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PropertyHistory.vue?vue&type=style&index=1&id=60d7814b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7814b",
  null
  
)

export default component.exports